import ApiService from "../../../services/ApiService";

const BASE = "/v1/leader-board";

function buildSort(sort) {
    if (!Array.isArray(sort) || sort.length === 0) return "score:desc";
    return sort.map((s) => `${s.field}:${s.sort}`).join(",");
}

function totalElements(result) {
    if (!result || typeof result !== "object") return 0;
    return result.totalElements ?? result.page?.totalElements ?? 0;
}

const LeaderBoardService = {
    listStandings: async (paginationModel, sort, { keyword = "", puzzleType = "", testFilter = "all", period = "all-time" } = {}) => {
        const params = {
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sort: buildSort(sort),
            testFilter: testFilter === "testers" || testFilter === "exclude" ? testFilter : "all",
        };
        if (keyword) params.keyword = keyword;
        if (puzzleType) params.puzzleType = puzzleType;
        if (period === "today" || period === "week") params.period = period;
        return ApiService.getData(BASE, params);
    },

    addRandomScore: async (standingId) => {
        return ApiService.postData(`${BASE}/${standingId}/add-random-score`, {});
    },

    removeStanding: async (standingId) => {
        return ApiService.deleteData(`${BASE}/${standingId}`);
    },

    addTestAccount: async (alias, puzzleType, score) => {
        const params = new URLSearchParams();
        params.set("alias", alias);
        params.set("puzzleType", puzzleType);
        params.set("score", String(score));
        return ApiService.postData(`${BASE}/test-account?${params.toString()}`, {});
    },

    /**
     * POST /v1/leader-board/sync-from-plays?puzzleType=JIGSAW|SLIDING|WORD_WHEEL
     * Jigsaw and sliding use completed play counts. Word Wheel uses words found.
     */
    syncFromPlays: async (puzzleType) => {
        const type = puzzleType ? String(puzzleType).trim() : "";
        if (!type) {
            return { error: "puzzleType required" };
        }
        return ApiService.postData(
            `${BASE}/sync-from-plays?puzzleType=${encodeURIComponent(type)}`,
            {},
        );
    },

    totalElements,
};

export default LeaderBoardService;
